import React, { FC, ReactNode } from 'react';
import { FlexBox } from '../../global/FlexBox';
import { getIntakeRequestTypeFields } from './requestTypeConfig';
import { IntakeRequest } from '../types';
import { DetailsField } from '../DetailsField';

interface IntakeRequestTypeFieldsProps {
  requestTypeDetails: IntakeRequest['requestTypeDetails'];
}

const IntakeRequestTypeFields: FC<IntakeRequestTypeFieldsProps> = ({
  requestTypeDetails,
}) => {
  const renderFieldValue = (
    item: string | string[] | boolean | undefined,
  ): ReactNode => {
    if (Array.isArray(item)) {
      return item.map((s: string, index: number) => (
        <p key={index} style={{ margin: 0 }}>
          {s}
        </p>
      ));
    }

    if (typeof item === 'boolean') {
      return item ? 'Yes' : 'No';
    }

    return item;
  };

  const shouldRenderField = (item: string | string[] | boolean | undefined): boolean => {
    if (typeof item === 'boolean') return true;
    if (Array.isArray(item)) return item.length > 0;
    return Boolean(item);
  };

  return (
    <FlexBox direction="column" sx={{ alignItems: 'flex-start' }}>
      {getIntakeRequestTypeFields(requestTypeDetails.type).map(field => {
        const item = (
          requestTypeDetails as unknown as Record<
            string,
            string | string[] | boolean
          >
        )[field.key];

        return shouldRenderField(item) ? (
          <DetailsField
            key={field.key}
            label={field.label}
            value={renderFieldValue(item)}
          />
        ) : null;
      })}
    </FlexBox>
  );
};

export default IntakeRequestTypeFields;
